import { useContext } from 'react'

import { Alert, Button, Card, Form, Input } from 'antd'
import { useNavigate } from 'react-router-dom'

import { useSignInApi } from '../hooks/'
import { AosTokenContext } from '../providers'

import type { FormProps } from 'antd'

type FieldType = {
  username: string
  password: string
}

export const SignIn: React.FC = () => {
  const [form] = Form.useForm<FieldType>()
  const username = Form.useWatch('username', form)
  const password = Form.useWatch('password', form)
  const { setToken } = useContext(AosTokenContext)
  const { trigger, error } = useSignInApi({ username, password })
  const navigate = useNavigate()

  const onFinish: FormProps<FieldType>['onFinish'] = async () => {
    const data = await trigger()

    if (data.token && data.expiry) {
      localStorage.setItem('aosToken', data.token)
      localStorage.setItem('aosTokenExpiry', data.expiry)
      setToken(data.token)
      navigate('/')
    }
  }

  return (
    <Card
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {error && (
        <Alert
          message="Error"
          description="Failed to sign in."
          type="error"
          showIcon
          style={{ width: 300, marginBottom: 16 }}
        />
      )}
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        style={{ width: 300 }}
        form={form}
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
